"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.replace");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/defineProperty"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _FirebaseStorageUtil = _interopRequireDefault(require("@/views/mixin/FirebaseStorageUtil"));

var _auth = require("../../utils/auth");

var _validate = require("@/utils/validate");

var _title_widget = _interopRequireDefault(require("@/views/widgets/title_widget.vue"));

var _button_widget = _interopRequireDefault(require("@/views/widgets/button_widget.vue"));

var _constants = require("@/utils/constants");

var _components$computed$;

var _default = (_components$computed$ = {
  components: {
    TitleWidget: _title_widget.default,
    Button: _button_widget.default
  },
  computed: {},
  mixins: [_FirebaseStorageUtil.default],
  data: function data() {
    var _this = this,
        _rules;

    var validateMaxLength = function validateMaxLength(rule, value, callback) {
      if (value.trim() === '' || value === null) {
        callback(new Error(rule.colname + 'を入力してください。'));
      } else if (value.length > rule.maxLen) {
        callback(new Error(rule.colname + 'は' + rule.maxLen + '桁の数値を入力してください。'));
      } else {
        callback();
      }
    };

    var validateFiles = function validateFiles(rule, value, callback) {
      if (_this.handleErrorFile()) {
        callback(new Error(rule.colname + _this.form.error));
      } else {
        callback();
      }
    };

    var validateSelectBox = function validateSelectBox(rule, value, callback) {
      if (value !== '') {
        callback();
      } else {
        callback(new Error('選択してください'));
      }
    };

    var validateSurvey = function validateSurvey(rule, value, callback) {
      if (_this.form.showSurvey) {
        if (_this.form.survey.question) {
          callback();
        } else {
          callback(new Error(rule.colname + 'を入力してください。'));
        }
      } else callback();
    };

    return {
      form: {
        publish_at: '',
        title: '',
        content: '',
        push_notification: true,
        fileList: [],
        error: '',
        categoryId: null,
        showSurvey: false,
        survey: {
          radio: 0,
          question: '',
          is_public_result: false,
          questions: [{
            errorSurvey: '',
            content: ''
          }, {
            errorSurvey: '',
            content: ''
          }]
        }
      },
      rules: (_rules = {
        title: [{
          required: true,
          validator: validateMaxLength,
          colname: 'タイトル',
          maxLen: 40
        }],
        content: [{
          required: true,
          validator: validateMaxLength,
          colname: '内容',
          maxLen: 1000
        }],
        fileList: [{
          required: false,
          validator: validateFiles,
          colname: 'ファイル'
        }],
        categoryId: [{
          required: true,
          validator: validateSelectBox,
          colname: 'カテゴリー'
        }],
        question: [{
          required: true,
          validator: validateSurvey,
          colname: '質問'
        }]
      }, (0, _defineProperty2.default)(_rules, "content", [{
        required: true,
        validator: validateSurvey,
        colname: '質問'
      }]), (0, _defineProperty2.default)(_rules, "publish_at", [{
        required: true,
        validator: validateSelectBox,
        colname: '状態'
      }]), _rules),
      addDialogVisible: false,
      waitDialogVisible: false,
      validateMaxLength: function validateMaxLength(rule, value, callback) {
        if (value.trim() === '' || value === null) {
          callback(new Error(rule.colname + 'を入力してください。'));
        } else if (value.length > rule.maxLen) {
          callback(new Error(rule.colname + 'は' + rule.maxLen + '桁の数値を入力してください。'));
        } else {
          callback();
        }
      },
      validateFiles: function validateFiles(rule, value, callback) {
        if (_this.handleErrorFile()) {
          callback(new Error(rule.colname + _this.form.error));
        } else {
          callback();
        }
      },
      validateSelectBox: function validateSelectBox(rule, value, callback) {
        if (value !== '') {
          callback();
        } else {
          callback(new Error('選択してください'));
        }
      },
      validateSurvey: function validateSurvey(rule, value, callback) {
        if (_this.form.showSurvey) {
          if (_this.form.survey.question) {
            callback();
          } else {
            callback(new Error(rule.colname + 'を入力してください。'));
          }
        } else callback();
      }
    };
  }
}, (0, _defineProperty2.default)(_components$computed$, "computed", {
  bulletinCategories: function bulletinCategories() {
    return this.$store.getters.bulletinCategories;
  },
  situation: function situation() {
    return this.$store.getters.situation;
  }
}), (0, _defineProperty2.default)(_components$computed$, "mounted", function () {
  var _mounted = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            this.$store.commit('bulletin/setOptionValue', 1);
            _context.next = 3;
            return this.$store.dispatch('bulletin/getBulletinCategories');

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function mounted() {
    return _mounted.apply(this, arguments);
  }

  return mounted;
}()), (0, _defineProperty2.default)(_components$computed$, "methods", {
  goToIndex: function goToIndex() {
    this.$router.replace({
      name: 'BulletinIndex'
    });
  },
  createSurvey: function createSurvey() {
    this.form.showSurvey = true;
  },
  validateSurveyQuestion: function validateSurveyQuestion() {
    if (!this.form.showSurvey) {
      return false;
    }

    var hasError = false;
    this.form.survey.questions.forEach(function (item) {
      if (item.content === '' || item.content === null) {
        item.errorSurvey = '選択肢を入力してください。';
        hasError = true;
      } else item.errorSurvey = '';
    });
    if (hasError) return true;else return false;
  },
  bytesToSize: function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return 'n/a';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    if (i === 0) return "".concat(bytes, " ").concat(sizes[i], ")");
    return "".concat((bytes / Math.pow(1024, i)).toFixed(1), " ").concat(sizes[i]);
  },
  handleRemove: function handleRemove(file, fileList) {
    this.form.fileList.splice(this.form.fileList.indexOf(file), 1);
  },
  handleExceed: function handleExceed(files, fileList) {
    this.$message.warning('アップロードできるファイルは5つまでです');
  },
  messageError: function messageError(text) {
    return this.$message({
      showClose: true,
      message: text,
      duration: 8000,
      type: 'error'
    });
  },
  handleErrorFile: function handleErrorFile(hidden) {
    var _this2 = this;

    function bytesToMegaBytes(bytes) {
      return (bytes / (1024 * 1024)).toFixed(2);
    } /// hiddenがtrueの場合、ファイルを追加するときに日付を確認します


    if (hidden) {
      this.$refs['upload'].validate(function (value) {
        return false;
      });
    }

    if (this.form.fileList) {
      if (this.form.fileList.some(function (item) {
        return bytesToMegaBytes(item.size) > 20;
      })) {
        this.form.error = '20MB以下のファイルのみを添付する可能です。';
        return true;
      }

      var hasSome = false;
      this.form.fileList.forEach(function (item, index) {
        if (item.nameSave) {
          if (_this2.form.fileList.some(function (some) {
            return some.nameSave === item.nameSave && some.uid !== item.uid;
          })) {
            _this2.form.fileList.splice(index, 1);

            hasSome = true;
          }
        }
      });
      this.form.error = '既に添付されているファイルです。';
      if (hasSome) return true;
    }
  },
  handleChange: function handleChange(file, fileList) {
    var _this3 = this;

    this.form.error = '';
    fileList.forEach(function (item, index) {
      if (!item.replace) {
        item.nameSave = item.name;
        item.name = item.name + ' ' + "(".concat(_this3.bytesToSize(item.size), ")");
      }

      item.replace = true;
    });
    this.form.fileList = fileList;
    this.handleErrorFile(true);
  },
  postFromCheck: function postFromCheck() {
    var _this4 = this;

    // エラーが発生した場合は停止します
    this.$refs['form'].validate(
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(value) {
        var questionText, questionYesOrNo;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this4.validateSurveyQuestion()) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", false);

              case 4:
                if (!value) {
                  _context2.next = 13;
                  break;
                }

                questionText = 'この掲示を下書きとして保存します。よろしいですか？';

                if (_this4.form.publish_at) {
                  questionText = 'この掲示をアプリへ公開します。よろしいですか？';
                }

                _context2.next = 9;
                return (0, _constants.message_box_confirm)('確認', questionText, '投稿', 'message_default');

              case 9:
                questionYesOrNo = _context2.sent;

                if (questionYesOrNo) {
                  _this4.onAdd();
                }

                _context2.next = 15;
                break;

              case 13:
                _this4.log('error submit!!');

                return _context2.abrupt("return", false);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  onAdd: function () {
    var _onAdd = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      var _this5 = this;

      var index, zoneId, file_name_extract, path, fileURL, saveBulletin, success_message;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              this.waitDialogVisible = true;
              this.addDialogVisible = false;

              if (!(this.form.fileList.length !== 0)) {
                _context3.next = 21;
                break;
              }

              index = 0;

            case 4:
              if (!(index < this.form.fileList.length)) {
                _context3.next = 21;
                break;
              }

              _context3.next = 7;
              return (0, _auth.getZoneId)();

            case 7:
              zoneId = _context3.sent;
              file_name_extract = (0, _validate.extractExtAndNameFromFilename)(this.form.fileList[index].nameSave);
              path = "bulletins/".concat(zoneId, "/").concat(file_name_extract.nameFile, "-").concat((0, _v.default)(), ".").concat(file_name_extract.extension);
              _context3.next = 12;
              return this.uploadFileToStorage(this.form.fileList[index].raw, path);

            case 12:
              fileURL = _context3.sent;

              if (!(fileURL === null)) {
                _context3.next = 17;
                break;
              }

              console.log('ファイルのアップロードに失敗しました。');
              this.waitDialogVisible = false;
              return _context3.abrupt("return");

            case 17:
              this.form.fileList[index].url = fileURL;

            case 18:
              index++;
              _context3.next = 4;
              break;

            case 21:
              _context3.next = 23;
              return this.$store.dispatch('bulletin/insertBulletin', this.form).catch(function (error) {
                _this5.waitDialogVisible = false;

                _this5.$notify({
                  title: 'エラー',
                  message: '作成に失敗しました。',
                  type: 'error',
                  duration: 10000,
                  showClose: true
                });

                console.log(error);
                throw error;
              });

            case 23:
              saveBulletin = _context3.sent;

              if (saveBulletin) {
                this.waitDialogVisible = false;
                success_message = '下書きを保存しました';

                if (this.form.publish_at) {
                  success_message = '掲示を公開しました';
                }

                this.$notify({
                  title: '情報',
                  message: success_message,
                  type: 'success',
                  duration: 2000
                });
                this.$router.replace({
                  name: 'BulletinIndex'
                });
              }

            case 25:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function onAdd() {
      return _onAdd.apply(this, arguments);
    }

    return onAdd;
  }(),
  addSelection: function addSelection() {
    this.form.survey.questions.push({
      errorSurvey: '',
      content: ''
    });
  },
  deleteSelection: function deleteSelection(index) {
    this.form.survey.questions.splice(index, 1);
  },
  resetSurvey: function resetSurvey() {
    this.form.showSurvey = false;
    this.form.survey = {
      radio: 0,
      question: '',
      questions: [{
        errorSurvey: '',
        content: ''
      }, {
        errorSurvey: '',
        content: ''
      }]
    };
  },
  handleDeleteItem: function () {
    var _handleDeleteItem = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5() {
      var _this6 = this;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              this.$confirm('このアンケートをキャンセルします。／よろしいですか？', '確認', {
                confirmButtonText: 'はい',
                cancelButtonText: 'いいえ',
                center: true
              }).then(
              /*#__PURE__*/
              (0, _asyncToGenerator2.default)(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        _this6.form.showSurvey = false;
                        _this6.form.survey = {
                          radio: 0,
                          question: '',
                          questions: [{
                            errorSurvey: '',
                            content: ''
                          }, {
                            errorSurvey: '',
                            content: ''
                          }]
                        };

                      case 2:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              })));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function handleDeleteItem() {
      return _handleDeleteItem.apply(this, arguments);
    }

    return handleDeleteItem;
  }()
}), _components$computed$);

exports.default = _default;